export const SET_PENDING_BOOKING_REVIEWS = 'PRO/SET_PENDING_BOOKING_REVIEWS'
export type SET_PENDING_BOOKING_REVIEWS = typeof SET_PENDING_BOOKING_REVIEWS

export const SET_APPROVED_BOOKING_REVIEWS = 'PRO/SET_APPROVED_BOOKING_REVIEWS'
export type SET_APPROVED_BOOKING_REVIEWS = typeof SET_APPROVED_BOOKING_REVIEWS

export const SET_REJECTED_BOOKING_REVIEWS = 'PRO/SET_REJECTED_BOOKING_REVIEWS'
export type SET_REJECTED_BOOKING_REVIEWS = typeof SET_REJECTED_BOOKING_REVIEWS
